import * as am4core from "@amcharts/amcharts4/core"
import {DropShadowFilter} from "@amcharts/amcharts4/core"

export function dropShadowFilter(): DropShadowFilter {
  const filter = new am4core.DropShadowFilter()
  filter.height = 100
  filter.opacity = 0.3
  filter.blur = 7
  filter.dx = 5
  filter.dy = 5
  return filter
}
